import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page views when route changes
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.href,
        page_type: location.pathname === '/' ? 'home' : location.pathname.substring(1)
      });
    }
  }, [location]);

  useEffect(() => {
    // Track course interest based on URL
    const trackCourseInterest = () => {
      if (window.gtag && location.pathname.includes('courses')) {
        window.gtag('event', 'course_interest', {
          event_category: 'engagement',
          event_label: 'course_page_view'
        });
      }
    };

    trackCourseInterest();
  }, [location]);

  useEffect(() => {
    // Track contact page visits
    if (window.gtag && location.pathname === '/contact') {
      window.gtag('event', 'contact_page_visit', {
        event_category: 'engagement',
        event_label: 'contact_page'
      });
    }
  }, [location]);

  useEffect(() => {
    // Track gallery page visits
    if (window.gtag && location.pathname === '/gallery') {
      window.gtag('event', 'gallery_page_visit', {
        event_category: 'engagement',
        event_label: 'gallery_page'
      });
    }
  }, [location]);

  useEffect(() => {
    // Track about page visits
    if (window.gtag && location.pathname === '/about') {
      window.gtag('event', 'about_page_visit', {
        event_category: 'engagement',
        event_label: 'about_page'
      });
    }
  }, [location]);

  useEffect(() => {
    // Track careers page visits
    if (window.gtag && location.pathname === '/careers') {
      window.gtag('event', 'careers_page_visit', {
        event_category: 'engagement',
        event_label: 'careers_page'
      });
    }
  }, [location]);

  return null; // This component doesn't render anything
};

export default AnalyticsTracker;
